import { connect } from 'react-redux'
import MutedNotification from './MutedNotification'
import { State } from '../../dataStore/reducers/reducerType'
import { mediaType } from '@bt-react/constants'
import { PlayInStatus } from '../../lib/playIn/types'

const mapStateToProps = (state: State) => {

  return {
    selectedAudioDeviceId: state.tracks.selectedAudioDeviceID,
    isLocalParticipantMuted: state.syncUi.mute.includes(state.user.BTID),
    hidden: (state.room.mediaType === mediaType.PLAY_IN && state.playIn.status === PlayInStatus.PLAYING) || state.room.mediaType === mediaType.EVENT_STREAM
  }

}

export default connect(mapStateToProps)(MutedNotification)
